<template>
  <b-modal
    :no-close-on-backdrop="true"
    id="taxrate"
    size="md"
    body-class="bg-white"
    cancel-title="Cancel"
    cancel-variant="light"
    :ok-title-html="
      this.page == 'update'
        ? submitted == true
          ? loaderIcon + 'Update'
          : 'Update'
        : submitted == true
        ? loaderIcon + 'Save'
        : 'Save'
    "
    :ok-disabled="submitted"
    @ok.prevent="onSubmit"
    title="Add Tax Rate"
    ref="taxrate"
    @shown="
      page == 'create' ? createFreshEventObject() : updateFreshEventObject()
    "
  >
    <b-alert class="alert-transparent alert-danger" :show="(error_show && this.errors.any())||(terms&&page=='update')">
      <button type="button" v-if="terms&&page=='update'" @click="terms = !terms" class="close">
        <span aria-hidden="true">&times;</span>
      </button>
       <button type="button" v-else @click="error_show = !error_show" class="close">
        <span aria-hidden="true">&times;</span>
      </button>
      <div v-for="item in errors.items" :key="item.id" >
        <p class="fw-semi-bold">{{ item.msg }}</p>
      </div>
        <div v-if="page=='update'&&terms">
        <p class="fw-semi-bold">{{ term_msg }}</p>
      </div>
    </b-alert>
    <b-row class="px-0" v-if="page == 'create' || page == 'update'" align-h="center">
      <b-col class="px-4" cols="12">
        <b-form-group
          horizontal
          :label-cols="3"
          :label="'Tax Name'"
          label-class="required"
          label-for="tax_name"
        >
          <b-form-input
            type="text"
            size="sm"
            name="Tax Name"
            data-vv-name="tax name"
            @input="is_change=1"
            v-model.trim="field.tax_name"
            v-validate="'required|max:50'"
          />
        </b-form-group>
        <b-form-group
          horizontal
          :label-cols="3"
          :label="'Tax Percent'"
          label-class="required"
          label-for="tax_percent"
        >
          <b-form-input
            type="text"
            size="sm"
            name="Tax Percent"
            data-vv-name="tax percent"
            v-model.trim="field.tax_percent"
            @input="is_change=1"
            v-validate="'required|decimal:5|max_value:100'"
          />
        </b-form-group>
        <b-form-group
          horizontal
          :label-cols="3"
          :label="'Tax Type'"
          label-class="required"
          label-for="tax_type"
        >
          <v-select
            :clearable="false"
            :disabled="page == 'update' && list.is_used > 0 ? true : false"
            id="search-select"
            @input="is_change=1"
            v-model.trim="field.tax_type"
            name="Tax Type"
            data-vv-name="tax type"
            v-validate="'required'"
            size="sm"
            index="value"
            label="label"
            :options="details.tax_type"
          />
        </b-form-group>
      </b-col>
    </b-row>
      <div v-if="page=='update'&&is_change==1">
             <p>The updated taxes will reflect in the following transaction(s), wherever the tax group has been applied. Select the boxes below to update the taxes in them.</p>
              <b-form-checkbox
                      plain
                      v-model.trim="field.update_draft_inv"
                      name="update_draft_inv"
                      :true-value="1"
                      :false-value="0"
                      class="mb-4"
                    >Draft Invoices
                </b-form-checkbox>
                 <b-form-checkbox
                      plain
                      v-model.trim="field.update_rec_trans"
                      name="update_rec_trans"
                      :true-value="1"
                      :false-value="0"
                      class="mb-4"
                      disabled
                    >Recurring Transactions
                </b-form-checkbox>
                <p class="fw-semi-bold">Terms and Conditions</p>
                    <b-form-checkbox
                      plain
                      v-model.trim="field.terms_and_conditions"
                      name="Terms and Conditions"
                      :true-value="1"
                      :false-value="0"
                      class="mb-4"
                    >I understand that updating the tax will mark the existing tax inactive, create a new tax, and update it in the chosen transactions.
                </b-form-checkbox>
         </div>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import $ from "jquery"; // for using jquery function
import vSelect from "vue-select"; // vue seatch select component
export default {
  props: ["page", "detailupdate", "list"],
  components: {
    vSelect
  },
  data() {
    return {
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      error_show: false,
       terms:false,
      term_msg:"",
      is_change:0,
      field: {
        tax_name: "",
        tax_type: "",
        tax_percent: "",
        old_tax_percent: "",
        update_rec_trans:"",
        update_draft_inv:"",
        terms_and_conditions:""
      }
    };
  },
  methods: {
    createFreshEventObject() {
      this.error_show = false;
      this.field = {
        tax_name: "",
        tax_type: "",
        tax_percent: "",
        old_tax_percent: "",
        update_rec_trans:"",
        update_draft_inv:"",
        terms_and_conditions:""
      };
      this.error_show = false;
      this.terms=false
    },
    updateFreshEventObject() {
      this.error_show = false;
      this.field.update_rec_trans=true,
      this.is_change=0;
      this.field.tax_name = this.list.tax_name;
      this.field.tax_type = this.list.tax_type_id;
      this.field.tax_percent = this.list.tax_percent;
      this.field.old_tax_percent = this.list.tax_percent;
      this.terms=false
    },
    onSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
             if(!this.field.terms_and_conditions&&this.page=='update'&&this.is_change==1){
          this.terms=true;
          this.term_msg="Please read and accept the Terms and Conditions"
        }
        else{
          this.submitted = true;
          var data = JSON.stringify(this.field);
          var url = "createtaxrate";
          if (this.page == "update") {
            url = "updatetaxrate";
            data = {
              id: this.list.tax_id,
              data: JSON.stringify(this.field)
            };
          }

          this.$store.dispatch("taxgroup/" + url, data).then(() => {
            this.submitted = false;
            if (this.type != "danger") {
              this.$emit("updateTaxpage");
              this.$refs.taxrate.hide();
            }
            // to show the alert message for success or error after api call
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: this.message,
              type: this.type,
              showCloseButton: true
            });
          });
        } 
        }else {
          // Scroll to error message show
          $(".modal-body").scrollTop(0);
          this.error_show = true;
        }
      });
    }
  },
  computed: {
    ...mapState({
      details: state => state.taxgroup.details,
      message: state => state.taxgroup.message,
      type: state => state.taxgroup.type
    })
  }
};
</script>

<style>
</style>
